<template>
  <v-container class="grey-lighten-3 ">
    <v-row justify="center">
      <v-col cols="12" xl="10">
        <v-sheet class="report-paper pa-6" elevation="3" id="printable-area">

          <div class="invoice-container">
            <div class="invoice-content" >
              <table style="width: 100%; border-collapse: collapse;">
                <thead>
                  <tr v-if="master?.branch?.company?.header_image">
                    <td colspan="100%">
                      <img :src="`${getFileServerUrl}${master?.branch?.company?.header_image}`" style="width: 100%;" alt="">
                    </td>
                  </tr>
                </thead>
                
                <tbody>
                  <!-- Header Section -->
                  <tr v-if="!master?.branch?.company?.header_image">
                    <td colspan="100%">
                      <div class="page-header">
                        <div class="header-section d-flex justify-space-between align-start">
                          <div class="company-info">
                            <h4 class="company-name">{{ master.branch?.company?.name || '' }}</h4>
                            <p class="company-text">{{ master.branch?.company?.address || '' }}</p>
                            <p class="company-text">
                              <v-icon size="small">mdi-phone-outline</v-icon>
                              {{ master.branch?.company?.mobile || '' }}
                            </p>
                            <p class="company-text">
                              <v-icon size="small">mdi-email-outline</v-icon>
                              {{ master.branch?.company?.email || '' }}
                            </p>
                          </div>
                          <div class="logo-container">
                            <v-img
                              :src="`${getFileServerUrl}/${master.branch?.company?.logo || 'uploads/demo_images/user.png'}`"
                              max-width="150"
                              max-height="70"
                              contain
                            />
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="100%">
                      <div class="text-center my-6">
                        <h2 class="report-title">MASTER SALES CONTRACT</h2>
                      </div>
                    </td>
                  </tr>

                  <!-- Master Box Section -->
                  <tr class="master-box-parent">
                    <td colspan="100%">
                      <div class="master-box mt-4" style="font-size: 13px;">
                        <v-row>
                          <v-col cols="6">
                            <table style="width: 100%; border-collapse: collapse; font-size: 12px;">
                              <tbody>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 4px;"><strong>Invoice Date</strong></td>
                                  <td style="border: 1px solid #000; padding: 4px;">{{ formatDate(master.invoice_date) }}</td>
                                </tr>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 4px;"><strong>Buyer Name</strong></td>
                                  <td style="border: 1px solid #000; padding: 4px;">{{ master?.buyer?.company_name || '-' }}</td>
                                </tr>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 4px;"><strong>Address</strong></td>
                                  <td style="border: 1px solid #000; padding: 4px;">{{ master?.buyer?.company_address || '-' }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </v-col>
                          <v-col cols="6">
                            <table style="width: 100%; border-collapse: collapse; font-size: 12px;">
                              <tbody>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 4px;"><strong>Invoice Number</strong></td>
                                  <td style="border: 1px solid #000; padding: 4px;">{{ master?.invoice_no || '-' }}</td>
                                </tr>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 4px;"><strong>MASTER SALES CONTRACT NO</strong></td>
                                  <td style="border: 1px solid #000; padding: 4px;">{{ master.code || '-' }}</td>
                                </tr>
                                <tr>
                                  <td style="border: 1px solid #000; padding: 4px;"><strong>Purchase Order (PO) NO</strong></td>
                                  <td style="border: 1px solid #000; padding: 4px;">{{ master.purchase_order_no || '-' }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="6">
                            <div style="height: 110px; border: 1px solid #000; padding: 8px;">
                              <strong>SUPPLIER / BENEFICIARY:</strong><br/>
                              {{ master?.branch?.company_name || '-' }}<br/>
                              {{ master?.branch?.company_address || '-' }}<br/>
                              Email: {{ master?.branch?.company_email || '-' }}<br/>
                              Phone: {{ master?.branch?.company_mobile || '-' }}
                            </div>
                          </v-col>
                          <v-col cols="6">
                            <div style="height: 110px; border: 1px solid #000; padding: 8px;">
                              <strong>BUYER NAME AND ADDRESS:</strong><br/>
                              {{ master?.buyer?.company_name || '-' }}<br/>
                              {{ master?.buyer?.company_address || '-' }}<br/>
                              Email: {{ master?.buyer?.company_email || '-' }}<br/>
                              Phone: {{ master?.buyer?.company_mobile || '-' }}
                            </div>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="6">
                            <div style="height: 130px; border: 1px solid #000; padding: 8px;">
                              <strong>SUPPLIER / BENEFICIARY BANK DETAILS:</strong><br/>
                              Bank Name: {{ master.beneficiary_bank?.name || 'N/A' }}<br/>
                              Bank Address: {{ master.beneficiary_bank?.address || 'N/A' }}<br/>
                              Branch: {{ master.beneficiary_bank?.branch || 'N/A' }}<br/>
                              Swift Code: {{ master.beneficiary_bank?.swift_code || 'N/A' }}<br/>
                              A/C No: {{ master.beneficiary_bank?.account_no || 'N/A' }}
                            </div>
                          </v-col>
                          <v-col cols="6">
                            <div style="height: 130px; border: 1px solid #000; padding: 8px;">
                              <strong>BUYER'S BANK DETAILS:</strong><br/>
                              Bank Name: {{ master.buyer_bank?.name || 'N/A' }}<br/>
                              Bank Address: {{ master.buyer_bank?.address || 'N/A' }}<br/>
                              Branch: {{ master.buyer_bank?.branch || 'N/A' }}<br/>
                              Swift Code: {{ master.buyer_bank?.swift_code || 'N/A' }}<br/>
                              A/C No: {{ master.buyer_bank?.account_no || 'N/A' }}
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </td>
                  </tr>

                  <!-- Details Table Row -->
                  <tr>
                    <td colspan="100%" style="border: none;">
                      <table class="dep-table order-table mt-4" style="width: 100%; border-collapse: collapse;">
                        <thead>
                          <tr>
                            <th style="border: 1px solid #000; padding: 8px;">PO NUMBER</th>
                            <th style="border: 1px solid #000; padding: 8px;">STYLE NUMBER</th>
                            <th style="border: 1px solid #000; padding: 8px;">DESCRIPTION</th>
                            <th style="border: 1px solid #000; padding: 8px;">HS CODE</th>
                            <th style="border: 1px solid #000; padding: 8px;">COMPOSITION</th>
                            <th style="border: 1px solid #000; padding: 8px;">COLOR NAME</th>
                            <th style="border: 1px solid #000; padding: 8px;">SIZE RANGE</th>
                            <th class="text-center" style="border: 1px solid #000; padding: 8px;">QUANTITY</th>
                            <th class="text-right" style="border: 1px solid #000; padding: 8px;">UNIT PRICE</th>
                            <th class="text-center" style="border: 1px solid #000; padding: 8px;">CURRENCY</th>
                            <th class="text-right" style="border: 1px solid #000; padding: 8px;">TOTAL AMOUNT</th>
                            <th style="border: 1px solid #000; padding: 8px;">EX-FACTORY</th>
                            <th style="border: 1px solid #000; padding: 8px;">ETD</th>
                            <th style="border: 1px solid #000; padding: 8px;">DESTINATION</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="row in master.details" :key="row.id">
                            <td style="border: 1px solid #000; padding: 8px;">{{ row.po || '-' }}</td>
                            <td style="border: 1px solid #000; padding: 8px;">{{ row.style_no || '-' }}</td>
                            <td style="border: 1px solid #000; padding: 8px;">{{ row.description || '-' }}</td>
                            <td style="border: 1px solid #000; padding: 8px;">{{ row.hs_code || '-' }}</td>
                            <td style="border: 1px solid #000; padding: 8px;">{{ row.composition || '-' }}</td>
                            <td style="border: 1px solid #000; padding: 8px;">{{ row.color_name || '-' }}</td>
                            <td style="border: 1px solid #000; padding: 8px;">{{ row.size_range || '-' }}</td>
                            <td class="text-center" style="border: 1px solid #000; padding: 8px;">{{ row.quantity || 0 }}</td>
                            <td class="text-right" style="border: 1px solid #000; padding: 8px;">{{ formatNumber(row.unit_price) }}</td>
                            <td style="border: 1px solid #000; padding: 8px;">{{ row.currency?.name || '-' }}</td>
                            <td class="text-right" style="border: 1px solid #000; padding: 8px;">{{ formatNumber(row.total_amount) }}</td>
                            <td style="border: 1px solid #000; padding: 8px;">{{ formatDate(row.cargo_receive_date) }}</td>
                            <td style="border: 1px solid #000; padding: 8px;">{{ formatDate(row.etd_date) }}</td>
                            <td style="border: 1px solid #000; padding: 8px;">{{ row.destination || '-' }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>

                  <!-- Summary Section -->
                  <tr>
                    <td colspan="100%" style="border: none;">
                      <table class="order-table mt-4" style="width: 100%; border-collapse: collapse;">
                        <tbody>
                          <tr>
                            <td colspan="11" class="text-right" style="border: 1px solid #000; padding: 8px;"><strong>GRAND TOTAL</strong></td>
                            <td class="text-right" style="border: 1px solid #000; padding: 8px;">
                              <strong>{{ formatNumber(master.total_amount) }}</strong>
                            </td>
                            <td colspan="2"></td>
                          </tr>

                          <tr>
                            <td colspan="5" class="text-center" style="border: 1px solid #000; padding: 8px;"><strong>Total</strong></td>
                            <td colspan="6" class="text-center" style="border: 1px solid #000; padding: 8px;"><strong>Amount in Words</strong></td>
                            <td colspan="3" class="text-center" style="border: 1px solid #000; padding: 8px;">
                              <strong>{{ convertNumberToWords(master.total_amount) }} ONLY</strong>
                            </td>
                          </tr>

                          <tr>
                            <td colspan="5" class="text-center" style="border: 1px solid #000; padding: 8px;"><strong>{{ formattedAdvancePayment }} Advance at Now</strong></td>
                            <td colspan="6" class="text-center" style="border: 1px solid #000; padding: 8px;"></td>
                            <td colspan="3" class="text-center" style="border: 1px solid #000; padding: 8px;">
                              <strong>{{ master.currency?.symbol || '$' }} {{ formatNumber(master.advance_payment_amount) }}</strong>
                            </td>
                          </tr>

                          <tr>
                            <td colspan="5" class="text-center" style="border: 1px solid #000; padding: 8px;"></td>
                            <td colspan="6" class="text-center" style="border: 1px solid #000; padding: 8px;"><strong>Amount in Words</strong></td>
                            <td colspan="3" class="text-center" style="border: 1px solid #000; padding: 8px;">
                              <strong>{{ convertNumberToWords(master.advance_payment_amount) }}</strong>
                            </td>
                          </tr>

                          <tr>
                            <td colspan="5" class="text-center" style="border: 1px solid #000; padding: 8px;"><strong>{{ formattedBalancePayment }} Balance will be paid Before Shipment</strong></td>
                            <td colspan="6" class="text-center" style="border: 1px solid #000; padding: 8px;"></td>
                            <td colspan="3" class="text-center" style="border: 1px solid #000; padding: 8px;">
                              <strong>{{ master.currency?.symbol || '$' }} {{ formatNumber(master.before_shipment_payment_amount) }}</strong>
                            </td>
                          </tr>

                          <tr>
                            <td colspan="5" class="text-center" style="border: 1px solid #000; padding: 8px;"></td>
                            <td colspan="6" class="text-center" style="border: 1px solid #000; padding: 8px;"><strong>Amount in Words</strong></td>
                            <td colspan="3" class="text-center" style="border: 1px solid #000; padding: 8px;">
                              <strong>{{ convertNumberToWords(master.before_shipment_payment_amount) }}</strong>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>

                  <!-- Shipment Terms Section -->
                  <tr>
                    <td colspan="100%" style="border: none;">
                      <table class="order-table mt-4" style="width: 100%; border-collapse: collapse;">
                        <thead>
                          <tr>
                            <th colspan="100%" class="text-left" style="border: 1px solid #000; padding: 8px; background: #ffffff;"><strong>CONDITION OF SHIPMENT:</strong></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td style="border: 1px solid #000; padding: 8px; width: 15%;"><strong>FROM</strong></td>
                            <td style="border: 1px solid #000; padding: 8px;">{{ master.loading_port?.name || '-' }}</td>
                            <td style="border: 1px solid #000; padding: 8px; width: 15%;"><strong>TO</strong></td>
                            <td style="border: 1px solid #000; padding: 8px;">{{ master.discharge_port?.name || '-' }}</td>
                            <td style="border: 1px solid #000; padding: 8px; width: 20%;"><strong>PAYMENT TERMS</strong></td>
                            <td style="border: 1px solid #000; padding: 8px;">{{ master.payment_term?.name || '-' }}</td>
                          </tr>

                          <tr>
                            <td style="border: 1px solid #000; padding: 8px;"><strong>SHIPMENT MODE</strong></td>
                            <td style="border: 1px solid #000; padding: 8px;">{{ master.shipping_method?.name || '-' }}</td>
                            <td style="border: 1px solid #000; padding: 8px;"><strong>INCOTERM</strong></td>
                            <td style="border: 1px solid #000; padding: 8px;">{{ master.incoterm?.name || '-' }}</td>
                            <td style="border: 1px solid #000; padding: 8px;"><strong>DATE OF EXPIRY</strong></td>
                            <td style="border: 1px solid #000; padding: 8px; background-color: #ffff00;">{{ formatDate(master.expiry_date) }}</td>
                          </tr>

                          <tr>
                            <td style="border: 1px solid #000; padding: 8px;"><strong>INSPECTION CERTIFICATE BY</strong></td>
                            <td style="border: 1px solid #000; padding: 8px;">ANOOSHA</td>
                            <td style="border: 1px solid #000; padding: 8px;"><strong>SHORT/EXCESS SHIPMENT</strong></td>
                            <td style="border: 1px solid #000; padding: 8px;">SHORT SHIPMENT NOT ALLOWED</td>
                            <td style="border: 1px solid #000; padding: 8px;"><strong>PARTIAL SHIPMENT</strong></td>
                            <td style="border: 1px solid #000; padding: 8px;">{{ master.partial_shipment || '-' }}</td>
                          </tr>

                          <tr>
                            <td style="border: 1px solid #000; padding: 8px;"><strong>PORT OF LOADING</strong></td>
                            <td style="border: 1px solid #000; padding: 8px;">{{ master.loading_port?.name || '-' }}</td>
                            <td style="border: 1px solid #000; padding: 8px;"><strong>PORT OF DESTINATION</strong></td>
                            <td style="border: 1px solid #000; padding: 8px;">{{ master.discharge_port?.name || '-' }}</td>
                            <td style="border: 1px solid #000; padding: 8px;"><strong>EARLY SHIPMENT</strong></td>
                            <td style="border: 1px solid #000; padding: 8px;">{{ master.early_shipment || '-' }}</td>
                          </tr>

                          <tr>
                            <td colspan="4"></td>
                            <td style="border: 1px solid #000; padding: 8px;"><strong>TRANSHIPMENT</strong></td>
                            <td style="border: 1px solid #000; padding: 8px;">{{ master.transhipment_shipment || '-' }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>

                  <!-- Additional Condition Section -->
                  <tr>
                    <td colspan="100%" style="border: none;">
                      <table class="order-table mt-4" style="width: 100%; border-collapse: collapse;">
                        <thead>
                          <tr>
                            <th class="text-left" style="border: 1px solid #000; padding: 8px; background: #ffffff;"><strong>ADDITIONAL CONDITION:</strong></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td style="border: 1px solid #000; padding: 8px; min-height: 100px; vertical-align: top; white-space: pre-wrap; word-wrap: break-word;">
                              {{ master.additional_condition || 'N/A' }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>

                  <!-- Signature Section -->
                  <tr>
                    <td colspan="100%" style="border: none;">
                      <v-row class="mt-8">
                        <v-col cols="6" class="text-center">
                          <div class="signature-box">
                            <div class="signature-line"></div>
                            <div class="signature-label">SEAL & SIGNATURE OF THE SUPPLIER / BENEFICIARY</div>
                          </div>
                        </v-col>

                        <v-col cols="6" class="text-center">
                          <div class="signature-box">
                            <div class="signature-line"></div>
                            <div class="signature-label">SEAL & SIGNATURE OF THE BUYER</div>
                          </div>
                        </v-col>
                      </v-row>
                    </td>
                  </tr>
                </tbody>

                <tfoot>
                  <tr>
                    <td colspan="100%" style="border:none">
                      <div style="width:100%;height: 100px;";>&nbsp;</div>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>

            <div class="invoice-footer">
              <img v-if="master?.branch?.company?.footer_image" :src="`${getFileServerUrl}${master?.branch?.company?.footer_image}`" alt="Footer Image" style="width: 100%; display: block;">
            </div>
          </div>

        </v-sheet>
      </v-col>
    </v-row>

    <!-- Print Button -->
    <v-row justify="center" class="d-print-none mt-4">
      <v-btn color="primary" prepend-icon="mdi-printer" @click="print">
        Print
      </v-btn>
    </v-row>

  </v-container>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import convertNumberToWords from "@/plugins/numberToWord";

const store = useStore();
const route = useRoute();

const master = ref({
  branch: {},
  buyer: {},
  details: [],
  beneficiary_bank: {},
  buyer_bank: {},
  currency: {}
});

const getFileServerUrl = computed(() => store.getters.getFileServerUrl);

function formatDate(date) {
  if (!date) return "-";
  return new Date(date).toLocaleDateString("en-GB");
}

function formatNumber(val) {
  if (val == null || val === "") return "";
  return Number(val).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

const formattedAdvancePayment = computed(() => {
  if (!master.value) return '';
  const value = master.value.advance_payment_value || 0;
  const type = master.value.advance_payment_type;

  if (type === 'percentage' || type === 'percent') {
    return `${value}%`;
  } else if (type === 'flat') {
    return `${value}`;
  } else {
    return `${value} ${type}`;
  }
});

const formattedBalancePayment = computed(() => {
  if (!master.value) return '';
  const value = master.value.before_shipment_payment_value || 0;
  const type = master.value.before_shipment_payment_type;

  if (type === 'percentage' || type === 'percent') {
    return `${value}%`;
  } else if (type === 'flat') {
    return `${value}`;
  } else {
    return `${value} ${type}`;
  }
});

function print() {
  const printContent = document.getElementById("printable-area").innerHTML;
  const printWindow = window.open("", "_blank", `width=${screen.width}, height=${screen.height}`);

  printWindow.document.write(`
    <!DOCTYPE html>
    <html>
    <head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Master Sales Contract</title>
    <link href="https://cdn.jsdelivr.net/npm/@mdi/font@7.4.47/css/materialdesignicons.min.css" rel="stylesheet">
    <style>
      * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
      }

      @page {
        size: A4;
        margin: 0;
        padding: 0;
      }

      html, body {
        margin: 0;
        padding: 0;
        width: 100%;
        height: 100%;
      }

      body { 
        font-family:"Times New Roman", serif; 
        background:#fff; 
        color:#000; 
        -webkit-print-color-adjust: exact; 
        print-color-adjust: exact;
      }

      .report-paper { 
        width: 100%; 
        padding: 0 !important;
        background: #fff;
        margin: 0;
      }

      .invoice-container {
        width: 100%;
        margin: 0;
        padding: 0;
      }

      .invoice-content {
        width: 100%;
        margin: 0;
        padding: 0;
      }

      header img {
        width: 100%;
        display: block;
        margin: 0;
        padding: 0;
      }

      table {
        width: 100%;
        margin: 0;
        padding: 0;
      }

      footer {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        z-index: 10;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }

      footer img {
        width: 100%;
        display: block;
        margin: 0;
        padding: 0;
      }

      .page-header {
        margin-bottom: 20px;
        padding: 20px 0;
      }

      .header-section { 
        display: flex; 
        justify-content: space-between; 
        align-items: flex-start; 
        border-bottom: 2px solid #eee; 
        padding-bottom: 10px; 
        margin-bottom: 16px; 
      }

      .company-name { 
        font-size: 20px; 
        font-weight: bold; 
        text-transform: uppercase; 
        margin: 0 0 4px 0; 
      }

      .company-text { 
        font-size: 14px; 
        margin: 2px 0; 
        display: flex; 
        align-items: center; 
      }

      .logo-container img { 
        max-height: 70px; 
        max-width: 150px; 
      }

      .report-title { 
        font-size: 20px; 
        text-align: center; 
        margin: 16px 0; 
      }

      .master-box {
        margin: 16px 0;
        font-size: 13px;
      }

      table { 
        width: 100% !important; 
        border-collapse: collapse; 
        font-size: 13px; 
        margin: 8px 0;
        background: white;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }

      th, td { 
        border: 1px solid #000; 
        padding: 6px; 
        vertical-align: middle; 
      }

      th { 
        background: #e0e0e0; 
        text-align: center; 
        font-weight: bold;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }

      .master-box-parent {
        border: none !important;
      }

      .text-center { text-align: center; }
      .text-right { text-align: right; }
      .text-left { text-align: left; }
      .mt-4 { margin-top: 16px !important; }
      .mt-8 { margin-top: 40px !important; }
      .my-6 { margin-top: 24px !important; margin-bottom: 24px !important; }

      img { 
        max-width: 100% !important; 
        height: auto !important; 
      }

      .d-flex { display: flex; }
      .justify-space-between { justify-content: space-between; }
      .align-start { align-items: flex-start; }
      .v-row { 
        display: flex !important; 
        flex-wrap: wrap !important; 
        margin: 0;
        width: 100%;
      }

      .v-col-6 { 
        flex: 0 0 50% !important; 
        max-width: 50% !important; 
        padding: 12px;
        box-sizing: border-box;
      }

      .pa-6 { padding: 0 !important; }

      .order-table thead {
        display: table-header-group;
      }

      .order-table tbody tr {
        page-break-inside: avoid;
      }

      .signature-box {
        font-size: 11px;
        border: 1px solid black;
        border-radius: 5px;
        padding: 10px;
      }

      .signature-line {
        border-bottom: 1px solid #000;
        margin: 50px 0
        height: 30px;
      }

      .signature-label {
        text-transform: uppercase;
        font-weight: bold;
        font-size: 10px;
      }

      .invoice-container {
        display: flex;
        flex-direction: column;
      }

      .invoice-content {
        flex: 1;
        overflow: hidden;
      }
        
      .company-info {
        flex: 1;
      }

      .invoice-footer {
        margin-top: auto;
        position: fixed;
        left: 0;
        bottom: 15px;
        width: 100%;
      }

      @media print { 
        body {
          margin: 0;
          padding: 0;
        }

        .report-paper {
          margin: 0;
          padding: 0;
        }

        main {
          padding-top: 180px;
          padding-bottom: 150px;
          padding-left: 20px;
          padding-right: 20px;
        }

        .order-table {
          page-break-inside: auto;
        }

        .order-table tr {
          page-break-inside: avoid;
          page-break-after: auto;
        }

        .order-table thead {
          display: table-header-group;
        }
      }
    </style>
    </head>
    <body>
      ${printContent}
    </body>
    </html>
  `);

  printWindow.document.close();
  printWindow.focus();
  setTimeout(() => printWindow.print(), 500);
}

onMounted(async () => {
  const res = await store.dispatch("getMasterSalesContact", route.params.id);
  if (res?.data?.success) {
    master.value = res.data.data;
  }
});
</script>

<style scoped>
.grey-lighten-3 { background-color: #eeeeee !important; }
.report-paper { background: white; }
.company-name { font-size: 20px; font-weight: bold; text-transform: uppercase; }
.company-text { font-size: 14px; }
.report-title { font-size: 20px; text-align: center; margin: 16px 0; }
.master-box { border: 1px solid #000; padding: 8px; font-size: 13px; margin-bottom: 16px; }
.dep-table { width: 100%; border-collapse: collapse; font-size: 13px; }
.dep-table th, .dep-table td { border: 1px solid #000; padding: 6px; }
.dep-table th { background: #e0e0e0; }
.text-center { text-align: center; }
.text-right { text-align: right; }
.text-left { text-align: left; }
.mt-4 { margin-top: 16px !important; }
.mt-8 { margin-top: 40px !important; }
.my-6 { margin-top: 24px !important; margin-bottom: 24px !important; }
.d-flex { display: flex; }
.justify-space-between { justify-content: space-between; }
.align-start { align-items: flex-start; }
.signature-box {
  font-size: 11px;
  border: 1px solid black;
  border-radius: 5px;
  padding: 10px;
  text-align: center;
  margin-top: 20px;
}

.signature-line {
  border-bottom: 1px solid #000;
  margin: 50px 0 8px 0;
  height: 30px;
}

.signature-label {
  text-transform: uppercase;
  font-weight: bold;
  font-size: 10px;
}

.page-header {
  margin-bottom: 20px;
}

.header-section {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-bottom: 2px solid #eee;
  padding-bottom: 10px;
  margin-bottom: 16px;
}

.company-info {
  flex: 1;
}

.logo-container {
  flex-shrink: 0;
  margin-left: 20px;
}

.order-table {
  width: 100%;
  border-collapse: collapse;
  margin: 15px 0;
}

.invoice-container {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

.invoice-content {
  flex: 1;
}

.invoice-footer {
  margin-top: auto;
}
</style>